export default [
  {
    id: '1da86484-bb92-72a8-5cb7-32307e541be2',
    path: '/error',
    name: 'ErrorPages',
    children: [
      {
        id: '5fb60a89-256b-431e-8201-96cabb87f882',
        path: '401',
        component: () => {
          return import('./errorPage/401')
        },
        name: '401',
        meta: { title: '401', tabnab: false }, // tabnab == false  不在layout-wiz 的tab标签中出现
      },
      {
        id: '34f7b73b-f827-42bc-97ae-c7f7b3256a2a',
        path: '404',
        component: () => {
          return import('./errorPage/404')
        },
        name: '404',
        meta: { title: '404', tabnab: false },
      },
    ],
  },
  {
    // 此路由配置信息要放置在最后
    // 否则会产生 RegExp.exec Maximum call stack size exceeded
    // todo: 需要探明下，这个之后是否还可以addRoute
    // 参看： 捕获所有路由或 404 Not found 路由
    // https://v3.router.vuejs.org/zh/guide/essentials/dynamic-matching.html
    id: 'bd474064-1f76-43cc-8bf0-2d595ec4d2cb',
    path: '*',
    redirect: './errorPage/404',
  },
]
